const PaymentSuccess = () => {
  return (
    <div className="text-white text-center p-10">
      <h2 className="text-3xl font-bold">Payment Successful! 🎉</h2>
      <p>Your course has been purchased.</p>
      <button className="w-300 mt-2 bg-yellow-400  text-black font-semibold py-2 rounded-md">
        Go to Course
      </button>
    </div>
  );
};

export default PaymentSuccess;


